"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "authenticateWithPasskey", {
  enumerable: true,
  get: function () {
    return _passkeyService.authenticateWithPasskey;
  }
});
_Object$defineProperty(exports, "clearAcknowledgedPasskeys", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.clearAcknowledgedPasskeys;
  }
});
_Object$defineProperty(exports, "clearKnownPasskeyUser", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.clearKnownPasskeyUser;
  }
});
_Object$defineProperty(exports, "clearRecommendPasskeysShown", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.clearRecommendPasskeysShown;
  }
});
_Object$defineProperty(exports, "deleteAllPasskeyCredentials", {
  enumerable: true,
  get: function () {
    return _passkeyService.deleteAllPasskeyCredentials;
  }
});
_Object$defineProperty(exports, "deletePasskeyCredential", {
  enumerable: true,
  get: function () {
    return _passkeyService.deletePasskeyCredential;
  }
});
_Object$defineProperty(exports, "getPasskeyCredentials", {
  enumerable: true,
  get: function () {
    return _passkeyService.getPasskeyCredentials;
  }
});
_Object$defineProperty(exports, "getPasskeyUserFlag", {
  enumerable: true,
  get: function () {
    return _passkeyService.getPasskeyUserFlag;
  }
});
_Object$defineProperty(exports, "hasAcknowledgedPasskeys", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.hasAcknowledgedPasskeys;
  }
});
_Object$defineProperty(exports, "hasSeenRecommendPasskeysModal", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.hasSeenRecommendPasskeysModal;
  }
});
_Object$defineProperty(exports, "isKnownPasskeyUser", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.isKnownPasskeyUser;
  }
});
_Object$defineProperty(exports, "isPasskeySupported", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.isPasskeySupported;
  }
});
_Object$defineProperty(exports, "registerPasskey", {
  enumerable: true,
  get: function () {
    return _passkeyService.registerPasskey;
  }
});
_Object$defineProperty(exports, "renamePasskeyCredential", {
  enumerable: true,
  get: function () {
    return _passkeyService.renamePasskeyCredential;
  }
});
_Object$defineProperty(exports, "setAcknowledgedPasskeys", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.setAcknowledgedPasskeys;
  }
});
_Object$defineProperty(exports, "setKnownPasskeyUser", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.setKnownPasskeyUser;
  }
});
_Object$defineProperty(exports, "setPasskeyUserFlag", {
  enumerable: true,
  get: function () {
    return _passkeyService.setPasskeyUserFlag;
  }
});
_Object$defineProperty(exports, "setRecommendPasskeysShown", {
  enumerable: true,
  get: function () {
    return _webauthnUtils.setRecommendPasskeysShown;
  }
});
var _passkeyService = require("./services/passkey-service");
var _webauthnUtils = require("./utils/webauthn-utils");